import { render } from "./DicomSettings.vue?vue&type=template&id=ec7e2a4c&scoped=true"
import script from "./DicomSettings.vue?vue&type=script&lang=js"
export * from "./DicomSettings.vue?vue&type=script&lang=js"

import "./DicomSettings.vue?vue&type=style&index=0&id=ec7e2a4c&scoped=true&lang=css"

import exportComponent from "/Users/erik/IdeaProjects/reportx/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec7e2a4c"]])

export default __exports__